var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(node,index){return _c('DepartmentTreeNode',{attrs:{"node":node},on:{"onNodeClick":_vm.onNodeClick}},[_vm._v(" "+_vm._s(node)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }